// Dummy data for village pages
// Each village has news, videos, gallery, and info

export const villageDummyData = {
  // Chitrakoot - Karvi Block
  "कर्वी": {
    blockName: "कर्वी ब्लॉक",
    districtName: "चित्रकूट",
    description: "कर्वी चित्रकूट जिले का एक प्रमुख गांव है। यहाँ की संस्कृति और परंपरा देश के अन्य हिस्सों से भिन्न है।",
    featured: {
      headline: "कर्वी गांव में नई सड़क परियोजना शुरू",
      description: "गांव को शहर से जोड़ने के लिए 50 किमी की नई सड़क बनाई जा रही है।",
      image: "https://www.aljazeera.com/news/",
      date: "12 मार्च 2026",
      reporter: "राज कुमार"
    },
    news: [
      {
        id: 1,
        headline: "कर्वी में नया स्कूल खुला",
        description: "गांव में 500 बच्चों के लिए एक आधुनिक स्कूल खुल गया है।",
        image: "https://images.loksattaimg.com/2026/03/New-Project-2026-03-13T162455.659.jpg?w=440",
        date: "10 मार्च",
        category: "शिक्षा"
      },
      {
        id: 2,
        headline: "कृषि मेले में किसानों की भीड़",
        description: "स्थानीय किसानों ने नई खेती की तकनीक सीखी।",
        image: "https://images.bhaskarassets.com/web2images/521/2026/03/13/61b1326c-19ba-4fe4-af0a-daadfa9e8130_1773375079455.jpg",
        date: "9 मार्च",
        category: "कृषि"
      },
      {
        id: 3,
        headline: "स्वास्थ्य शिविर का आयोजन",
        description: "गांव वासियों को मुफ्त स्वास्थ्य जांच प्रदान की गई।",
        image: "https://img.etimg.com/thumb/width-420,height-315,imgsize-46610,resizemode-75,msid-129551415/news/defence/iran-is-not-another-venezuela-trump-has-found-to-great-cost.jpg",
        date: "8 मार्च",
        category: "स्वास्थ्य"
      },
      {
        id: 4,
        headline: "बिजली समस्या का समाधान",
        description: "गांव में अब 24 घंटे बिजली की आपूर्ति होगी।",
        image: "https://img.mathrubhumi.com/view/acePublic/alias/contentid/1prpk90wxdwuz5rcml9/0/trisha-jpg.webp?f=16%3A9&q=0.75&w=532",
        date: "7 मार्च",
        category: "विकास"
      },
      {
        id: 5,
        headline: "महिला स्वयं सहायता समूह",
        description: "40 महिलाओं ने मिलकर एक सहकारिता समिति बनाई।",
        image: "https://akm-img-a-in.tosshub.com/aajtak/images/author/narendra-modi.png",
        date: "6 मार्च",
        category: "समाज"
      },
      {
        id: 6,
        headline: "युवाओं को कौशल प्रशिक्षण",
        description: "50 युवाओं को डिजिटल मार्केटिंग का प्रशिक्षण दिया गया।",
        image: "https://www.aljazeera.com/wp-content/uploads/2022/03/AP22056247719264.jpg?resize=770%2C513&quality=80",
        date: "5 मार्च",
        category: "शिक्षा"
      }
    ],
    videos: [
      {
        id: 1,
        title: "कर्वी गांव की सुंदरता",
        description: "गांव की प्राकृतिक सौंदर्य को दिखाता डॉक्यूमेंटरी।",
        youtubeId: "dQw4w9WgXcQ",
        thumbnail: "https://www.aljazeera.com/wp-content/uploads/2024/02/2023-05-13T105359Z_980250140_RC2LX0AASDF6_RTRMADP_3_INDIA-POLITICS-KARNATAKA-1708147172.jpg?resize=770%2C513&quality=80"
      },
      {
        id: 2,
        title: "किसान कहानियां",
        description: "स्थानीय किसानों की सफलता की कहानियां।",
        youtubeId: "jNQXAC9IVRw",
        thumbnail: "https://www.newsonair.gov.in/wp-content/uploads/2025/09/yogi.jpg"
      },
      {
        id: 3,
        title: "परंपरागत कला प्रदर्शन",
        description: "गांव की परंपरागत कला को संरक्षित करने की पहल।",
        youtubeId: "9bZkp7q19f0",
        thumbnail: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSkLxOl7IMykBJYvH40VacWM1b9ubR0NX2ivA&s"
      }
    ],
    gallery: [
      { id: 1, image: "https://www.aljazeera.com/news/", caption: "गांव का मुख्य चौपाल" },
      { id: 2, image: "https://images.loksattaimg.com/2026/03/New-Project-2026-03-13T162455.659.jpg?w=440", caption: "खेतों में कटाई का दृश्य" },
      { id: 3, image: "https://images.bhaskarassets.com/web2images/521/2026/03/13/61b1326c-19ba-4fe4-af0a-daadfa9e8130_1773375079455.jpg", caption: "महिला स्व-सहायता समूह" },
      { id: 4, image: "https://img.etimg.com/thumb/width-420,height-315,imgsize-46610,resizemode-75,msid-129551415/news/defence/iran-is-not-another-venezuela-trump-has-found-to-great-cost.jpg", caption: "गांव का प्राथमिक स्कूल" },
      { id: 5, image: "https://img.mathrubhumi.com/view/acePublic/alias/contentid/1prpk90wxdwuz5rcml9/0/trisha-jpg.webp?f=16%3A9&q=0.75&w=532", caption: "धार्मिक स्थल" },
      { id: 6, image: "https://akm-img-a-in.tosshub.com/aajtak/images/author/narendra-modi.png", caption: "गांव की सड़क" }
    ],
    relatedNews: [
      { headline: "पड़ोसी गांव में भी सड़क बिछाई जाएगी", views: "2.5K" },
      { headline: "कर्वी के युवा को राष्ट्रीय पुरस्कार", views: "1.8K" },
      { headline: "पर्यटन विकास की योजना", views: "3.2K" }
    ],
    blockNews: [
      { headline: "कर्वी ब्लॉक में जल संकट हल हुआ", link: "#" },
      { headline: "ब्लॉक के स्कूलों में बेहतरी आई", link: "#" },
      { headline: "कृषि उत्पादन में रिकॉर्ड", link: "#" }
    ]
  },

  // Chitrakoot - Pahadi Block
  "पहाड़ी": {
    blockName: "पहाड़ी ब्लॉक",
    districtName: "चित्रकूट",
    description: "पहाड़ी चित्रकूट की सबसे ऊंची और सुंदर बस्ती है। यहाँ की प्राकृतिक सौंदर्य अद्भुत है।",
    featured: {
      headline: "पहाड़ी गांव में पर्यटन केंद्र का निर्माण",
      description: "गांव की सुंदरता को दुनिया के सामने लाने के लिए पर्यटन केंद्र बनाया जा रहा है।",
      image: "https://www.aljazeera.com/wp-content/uploads/2022/03/AP22056247719264.jpg?resize=770%2C513&quality=80",
      date: "13 मार्च 2026",
      reporter: "प्रिया शर्मा"
    },
    news: [
      {
        id: 1,
        headline: "प्राकृतिक जल स्रोत का संरक्षण",
        description: "गांव के प्राचीन जल स्रोतों को संरक्षित करने का काम शुरू हुआ।",
        image: "https://www.aljazeera.com/wp-content/uploads/2024/02/2023-05-13T105359Z_980250140_RC2LX0AASDF6_RTRMADP_3_INDIA-POLITICS-KARNATAKA-1708147172.jpg?resize=770%2C513&quality=80",
        date: "12 मार्च",
        category: "पर्यावरण"
      },
      {
        id: 2,
        headline: "वन संरक्षण अभियान",
        description: "गांववासियों ने 1000 पेड़ लगाए।",
        image: "https://www.newsonair.gov.in/wp-content/uploads/2025/09/yogi.jpg",
        date: "11 मार्च",
        category: "पर्यावरण"
      },
      {
        id: 3,
        headline: "पहाड़ी पर ट्रेकिंग मार्ग",
        description: "पहाड़ी पर एक नया ट्रेकिंग मार्ग बनाया गया है।",
        image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSkLxOl7IMykBJYvH40VacWM1b9ubR0NX2ivA&s",
        date: "10 मार्च",
        category: "पर्यटन"
      },
      {
        id: 4,
        headline: "गांव में होमस्टे की व्यवस्था",
        description: "पर्यटकों के लिए 10 होमस्टे की व्यवस्था की गई है।",
        image: "https://www.aljazeera.com/news/",
        date: "9 मार्च",
        category: "पर्यटन"
      },
      {
        id: 5,
        headline: "स्थानीय कला का प्रदर्शन",
        description: "पहाड़ी की परंपरागत कलाओं का एक संग्रहालय बनाया जा रहा है।",
        image: "https://images.loksattaimg.com/2026/03/New-Project-2026-03-13T162455.659.jpg?w=440",
        date: "8 मार्च",
        category: "संस्कृति"
      },
      {
        id: 6,
        headline: "जैविक खेती का विस्तार",
        description: "गांव में 95% खेती अब जैविक तरीके से होती है।",
        image: "https://images.bhaskarassets.com/web2images/521/2026/03/13/61b1326c-19ba-4fe4-af0a-daadfa9e8130_1773375079455.jpg",
        date: "7 मार्च",
        category: "कृषि"
      }
    ],
    videos: [
      {
        id: 1,
        title: "पहाड़ी की मनोरम सुंदरता",
        description: "सूर्यास्त और सूर्योदय के दृश्य।",
        youtubeId: "dQw4w9WgXcQ",
        thumbnail: "https://img.etimg.com/thumb/width-420,height-315,imgsize-46610,resizemode-75,msid-129551415/news/defence/iran-is-not-another-venezuela-trump-has-found-to-great-cost.jpg"
      },
      {
        id: 2,
        title: "गांव के लोग",
        description: "पहाड़ी के लोगों की दिनचर्या।",
        youtubeId: "jNQXAC9IVRw",
        thumbnail: "https://img.mathrubhumi.com/view/acePublic/alias/contentid/1prpk90wxdwuz5rcml9/0/trisha-jpg.webp?f=16%3A9&q=0.75&w=532"
      }
    ],
    gallery: [
      { id: 1, image: "https://akm-img-a-in.tosshub.com/aajtak/images/author/narendra-modi.png", caption: "पहाड़ी का शिखर" },
      { id: 2, image: "https://www.aljazeera.com/wp-content/uploads/2022/03/AP22056247719264.jpg?resize=770%2C513&quality=80", caption: "सूर्यास्त का दृश्य" },
      { id: 3, image: "https://www.aljazeera.com/wp-content/uploads/2024/02/2023-05-13T105359Z_980250140_RC2LX0AASDF6_RTRMADP_3_INDIA-POLITICS-KARNATAKA-1708147172.jpg?resize=770%2C513&quality=80", caption: "प्राकृतिक वन" },
      { id: 4, image: "https://www.newsonair.gov.in/wp-content/uploads/2025/09/yogi.jpg", caption: "जल स्रोत" }
    ],
    relatedNews: [
      { headline: "पर्यटन से गांव की आय में बढ़ोतरी", views: "4.2K" },
      { headline: "पहाड़ी पर अंतर्राष्ट्रीय ट्रेकिंग", views: "5.1K" }
    ],
    blockNews: [
      { headline: "पहाड़ी ब्लॉक पर्यटन के लिए प्रसिद्ध हुआ", link: "#" },
      { headline: "ब्लॉक को हरित प्रमाणपत्र मिला", link: "#" }
    ]
  },

  // Default data for unknown villages
  "default": {
    blockName: "ब्लॉक",
    districtName: "चित्रकूट",
    description: "यह गांव चित्रकूट जिले का एक महत्वपूर्ण गांव है।",
    featured: {
      headline: "गांव में विकास परियोजना",
      description: "गांव के विकास के लिए नई परियोजना शुरू की गई है।",
      image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSkLxOl7IMykBJYvH40VacWM1b9ubR0NX2ivA&s",
      date: "13 मार्च 2026",
      reporter: "संवाददाता"
    },
    news: [
      {
        id: 1,
        headline: "गांव में नई सुविधा खुली",
        description: "गांववासियों के लिए एक नई सुविधा शुरू की गई है।",
        image: "https://www.aljazeera.com/news/",
        date: "12 मार्च",
        category: "विकास"
      },
      {
        id: 2,
        headline: "सामाजिक कार्यक्रम का आयोजन",
        description: "गांव में एक बड़ा सामाजिक कार्यक्रम का आयोजन किया गया।",
        image: "https://images.loksattaimg.com/2026/03/New-Project-2026-03-13T162455.659.jpg?w=440",
        date: "11 मार्च",
        category: "समाज"
      },
      {
        id: 3,
        headline: "युवाओं के लिए रोजगार",
        description: "गांव के युवाओं को नए रोजगार के अवसर मिल रहे हैं।",
        image: "https://images.bhaskarassets.com/web2images/521/2026/03/13/61b1326c-19ba-4fe4-af0a-daadfa9e8130_1773375079455.jpg",
        date: "10 मार्च",
        category: "रोजगार"
      },
      {
        id: 4,
        headline: "महिलाओं को प्रशिक्षण",
        description: "महिलाओं को कौशल विकास का प्रशिक्षण दिया जा रहा है।",
        image: "https://img.etimg.com/thumb/width-420,height-315,imgsize-46610,resizemode-75,msid-129551415/news/defence/iran-is-not-another-venezuela-trump-has-found-to-great-cost.jpg",
        date: "9 मार्च",
        category: "शिक्षा"
      },
      {
        id: 5,
        headline: "स्वास्थ्य सेवा में सुधार",
        description: "गांव में स्वास्थ्य सेवा को बेहतर बनाया गया है।",
        image: "https://img.mathrubhumi.com/view/acePublic/alias/contentid/1prpk90wxdwuz5rcml9/0/trisha-jpg.webp?f=16%3A9&q=0.75&w=532",
        date: "8 मार्च",
        category: "स्वास्थ्य"
      },
      {
        id: 6,
        headline: "पर्यावरण संरक्षण",
        description: "गांव में पर्यावरण संरक्षण का कार्य जारी है।",
        image: "https://akm-img-a-in.tosshub.com/aajtak/images/author/narendra-modi.png",
        date: "7 मार्च",
        category: "पर्यावरण"
      }
    ],
    videos: [
      {
        id: 1,
        title: "गांव की सुंदरता",
        description: "गांव की प्राकृतिक सौंदर्य।",
        youtubeId: "dQw4w9WgXcQ",
        thumbnail: "https://www.aljazeera.com/wp-content/uploads/2022/03/AP22056247719264.jpg?resize=770%2C513&quality=80"
      }
    ],
    gallery: [
      { id: 1, image: "https://www.aljazeera.com/wp-content/uploads/2024/02/2023-05-13T105359Z_980250140_RC2LX0AASDF6_RTRMADP_3_INDIA-POLITICS-KARNATAKA-1708147172.jpg?resize=770%2C513&quality=80", caption: "गांव का दृश्य" },
      { id: 2, image: "https://www.newsonair.gov.in/wp-content/uploads/2025/09/yogi.jpg", caption: "खेत" },
      { id: 3, image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSkLxOl7IMykBJYvH40VacWM1b9ubR0NX2ivA&s", caption: "स्कूल" },
      { id: 4, image: "https://www.aljazeera.com/news/", caption: "मंदिर" }
    ],
    relatedNews: [
      { headline: "पड़ोसी गांव में भी विकास", views: "1.5K" }
    ],
    blockNews: [
      { headline: "ब्लॉक में नई योजना", link: "#" }
    ]
  }
};

export function getVillageData(villageName) {
  // If exact match found, return it
  if (villageDummyData[villageName]) {
    return villageDummyData[villageName];
  }
  
  // Otherwise, auto-generate data for the village
  
  return {
    blockName: "ब्लॉक",
    districtName: "चित्रकूट",
    description: `${villageName} चित्रकूट जिले का एक महत्वपूर्ण गांव है। यहाँ की संस्कृति और परंपरा बहुत समृद्ध है। गांव के विकास के लिए विभिन्न सरकारी योजनाएं चल रही हैं।`,
    featured: {
      headline: `${villageName} गांव में नई विकास परियोजना`,
      description: `${villageName} गांव में एक महत्वपूर्ण विकास परियोजना शुरू की गई है। इस परियोजना से गांव वासियों को बड़ा लाभ मिलेगा।`,
      image: `https://images.loksattaimg.com/2026/03/New-Project-2026-03-13T162455.659.jpg?w=440`,
    },
    news: [
      {
        id: 1,
        headline: `${villageName} गांव में नई सुविधा`,
        description: "गांव में एक नई सुविधा शुरू की गई है जो गांववासियों के लिए बहुत लाभदायक साबित होगी।",
        image: "https://images.bhaskarassets.com/web2images/521/2026/03/13/61b1326c-19ba-4fe4-af0a-daadfa9e8130_1773375079455.jpg",
        date: new Date(Date.now() - 86400000).toLocaleDateString('hi-IN'),
        category: "विकास"
      },
      {
        id: 2,
        headline: "कृषि में नई तकनीक",
        description: "किसानों को आधुनिक कृषि तकनीकों का प्रशिक्षण दिया जा रहा है।",
        image: "https://img.etimg.com/thumb/width-420,height-315,imgsize-46610,resizemode-75,msid-129551415/news/defence/iran-is-not-another-venezuela-trump-has-found-to-great-cost.jpg",
        date: new Date(Date.now() - 172800000).toLocaleDateString('hi-IN'),
        category: "कृषि"
      },
      {
        id: 3,
        headline: "स्वास्थ्य शिविर का आयोजन",
        description: "गांव में एक विशेष स्वास्थ्य शिविर का आयोजन किया गया है।",
        image: "https://img.mathrubhumi.com/view/acePublic/alias/contentid/1prpk90wxdwuz5rcml9/0/trisha-jpg.webp?f=16%3A9&q=0.75&w=532",
        date: new Date(Date.now() - 259200000).toLocaleDateString('hi-IN'),
        category: "स्वास्थ्य"
      },
      {
        id: 4,
        headline: "शिक्षा में सुधार",
        description: "गांव के स्कूलों में शिक्षा की गुणवत्ता में सुधार लाया जा रहा है।",
        image: "https://akm-img-a-in.tosshub.com/aajtak/images/author/narendra-modi.png",
        date: new Date(Date.now() - 345600000).toLocaleDateString('hi-IN'),
        category: "शिक्षा"
      },
      {
        id: 5,
        headline: "महिला सशक्तिकरण",
        description: "महिलाओं को आर्थिक रूप से आत्मनिर्भर बनाने के लिए प्रशिक्षण दिया जा रहा है।",
        image: "https://www.aljazeera.com/wp-content/uploads/2022/03/AP22056247719264.jpg?resize=770%2C513&quality=80",
        date: new Date(Date.now() - 432000000).toLocaleDateString('hi-IN'),
        category: "समाज"
      },
      {
        id: 6,
        headline: "युवाओं को रोजगार",
        description: "गांव के युवाओं को विभिन्न कौशल प्रशिक्षण देकर रोजगार के अवसर प्रदान किए जा रहे हैं।",
        image: "https://www.aljazeera.com/wp-content/uploads/2024/02/2023-05-13T105359Z_980250140_RC2LX0AASDF6_RTRMADP_3_INDIA-POLITICS-KARNATAKA-1708147172.jpg?resize=770%2C513&quality=80",
        date: new Date(Date.now() - 518400000).toLocaleDateString('hi-IN'),
        category: "रोजगार"
      }
    ],
    videos: [
      {
        id: 1,
        title: `${villageName} की सुंदरता`,
        description: "गांव की प्राकृतिक सौंदर्य को दिखाता वीडियो।",
        youtubeId: "dQw4w9WgXcQ",
        thumbnail: "https://www.newsonair.gov.in/wp-content/uploads/2025/09/yogi.jpg"
      },
      {
        id: 2,
        title: "किसानों की कहानी",
        description: "गांव के किसानों की सफलता की कहानी।",
        youtubeId: "jNQXAC9IVRw",
        thumbnail: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSkLxOl7IMykBJYvH40VacWM1b9ubR0NX2ivA&s"
      },
      {
        id: 3,
        title: "संस्कृति और परंपरा",
        description: "गांव की संस्कृति और परंपरा को दिखाता वीडियो।",
        youtubeId: "9bZkp7q19f0",
        thumbnail: "https://www.aljazeera.com/news/"
      }
    ],
    gallery: [
      { id: 1, image: "https://images.loksattaimg.com/2026/03/New-Project-2026-03-13T162455.659.jpg?w=440", caption: "गांव का मुख्य चौपाल" },
      { id: 2, image: "https://images.bhaskarassets.com/web2images/521/2026/03/13/61b1326c-19ba-4fe4-af0a-daadfa9e8130_1773375079455.jpg", caption: "खेतों में कटाई का दृश्य" },
      { id: 3, image: "https://img.etimg.com/thumb/width-420,height-315,imgsize-46610,resizemode-75,msid-129551415/news/defence/iran-is-not-another-venezuela-trump-has-found-to-great-cost.jpg", caption: "महिला स्व-सहायता समूह" },
      { id: 4, image: "https://img.mathrubhumi.com/view/acePublic/alias/contentid/1prpk90wxdwuz5rcml9/0/trisha-jpg.webp?f=16%3A9&q=0.75&w=532", caption: "गांव का प्राथमिक स्कूल" },
      { id: 5, image: "https://akm-img-a-in.tosshub.com/aajtak/images/author/narendra-modi.png", caption: "धार्मिक स्थल" },
      { id: 6, image: "https://www.aljazeera.com/wp-content/uploads/2022/03/AP22056247719264.jpg?resize=770%2C513&quality=80", caption: "गांव की सड़क" }
    ],
    relatedNews: [
      { headline: "पड़ोसी गांव में भी सड़क बिछाई जाएगी", views: "2.5K" },
      { headline: "ब्लॉक के विकास में नई पहल", views: "1.8K" },
      { headline: "कृषि उत्पादन में रिकॉर्ड", views: "3.2K" }
    ],
    blockNews: [
      { headline: "ब्लॉक में नई योजना शुरू", link: "#" },
      { headline: "ब्लॉक के स्कूलों में बेहतरी", link: "#" },
      { headline: "ब्लॉक में कृषि का विकास", link: "#" }
    ]
  };
}
